import { render } from "./DadosDaImplantacao.vue?vue&type=template&id=0a61d20d&scoped=true&ts=true"
import script from "./DadosDaImplantacao.vue?vue&type=script&lang=ts"
export * from "./DadosDaImplantacao.vue?vue&type=script&lang=ts"

import "./DadosDaImplantacao.vue?vue&type=style&index=0&id=0a61d20d&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a61d20d"]])

export default __exports__